import { Clock3, Flag, UserRound, UsersRound } from "lucide-react";
import { MetricCard } from "@/components/metric-card";
import type { SummaryMetric } from "@/lib/report-metrics";
import { cn } from "@/lib/utils";

type SummaryCardProps = SummaryMetric;

type SummaryCardsProps = {
  metrics: SummaryMetric[];
  className?: string;
};

const ICONS: Record<
  string,
  React.ComponentType<{ className?: string }> | undefined
> = {
  "total-signins": UserRound,
  "unique-workers": UsersRound,
  "total-hours": Clock3,
  flagged: Flag,
};

export function SummaryCard({
  id,
  label,
  value,
  subLabel,
  accent = "default",
}: SummaryCardProps) {
  return (
    <MetricCard
      label={label}
      value={value}
      subLabel={subLabel}
      accent={accent}
      icon={ICONS[id]}
      href={id === "flagged" ? "/signins" : undefined}
    />
  );
}

export function SummaryCards({ metrics, className }: SummaryCardsProps) {
  if (!metrics.length) return null;

  return (
    <div
      className={cn(
        "grid grid-cols-2 gap-3 md:gap-4 xl:grid-cols-4",
        className
      )}
    >
      {metrics.map((metric) => (
        <SummaryCard key={metric.id} {...metric} />
      ))}
    </div>
  );
}
